import React, { useState } from "react";
import { format, parseISO, addMinutes } from "date-fns";
import { ptBR } from "date-fns/locale";
import { FaEdit, FaTrash } from "react-icons/fa";
import EditTransactionModal from "./EditTransactionModal";
import ConfirmDeleteModal from "./ConfirmDeleteModal";

const TransactionTable = ({ transactions, onRefresh }) => {
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [selectedTransaction, setSelectedTransaction] = useState(null);

    const handleEdit = (transaction) => {
        setSelectedTransaction(transaction);
        setEditModalOpen(true);
    };

    const handleDelete = (transaction) => {
        setSelectedTransaction(transaction);
        setDeleteModalOpen(true);
    };

    const handleCloseEditModal = () => {
        setEditModalOpen(false);
        onRefresh();
    };

    const handleCloseDeleteModal = () => {
        setDeleteModalOpen(false);
        onRefresh();
    };

    return (
        <div
            style={{
                backgroundColor: "white",
                borderRadius: "8px",
                boxShadow: "0 2px 10px rgba(0, 0, 0, 0.05)",
                overflowX: "auto",
            }}
        >
            <table
                style={{
                    width: "100%",
                    borderCollapse: "collapse",
                }}
            >
                <thead>
                    <tr
                        style={{
                            backgroundColor: "#f8f9fa",
                            borderBottom: "1px solid #ddd",
                        }}
                    >
                        <th style={tableHeaderStyle}>Data</th>
                        <th style={tableHeaderStyle}>
                            Descrição
                        </th>
                        <th style={tableHeaderStyle}>Valor</th>
                        <th style={tableHeaderStyle}>
                            Tipo
                        </th>
                        <th style={tableHeaderStyle}>
                            Pagamento
                        </th>
                        <th style={tableHeaderStyle}>Ações</th>
                    </tr>
                </thead>
                <tbody>
                    {transactions.length === 0 ? (
                        <tr>
                            <td colSpan="6" style={noTransactionsStyle}>
                                Nenhuma transação encontrada
                            </td>
                        </tr>
                    ) : (
                        transactions.map((transaction) => (
                            <tr
                                key={transaction.id}
                                style={{
                                    borderBottom: "1px solid #eee",
                                    "&:hover": {
                                        backgroundColor: "#f8f9fa",
                                    },
                                }}
                            >
                                <td style={tableCellStyle}>
                                    {format(
                                        addMinutes(parseISO(transaction.data_atualizacao), 0),
                                        "dd/MM/yyyy - HH:mm:ss",
                                        { locale: ptBR }
                                    )}
                                </td>
                                <td style={tableCellStyle}>
                                    {transaction.descricao}
                                </td>
                                <td
                                    style={{
                                        ...tableCellStyle,
                                        color: transaction.tipo === 'entrada' ? "#2ecc71" : "#e74c3c", // Cor baseada no tipo
                                    }}
                                >
                                    {new Intl.NumberFormat("pt-BR", {
                                        style: "currency",
                                        currency: "BRL",
                                    }).format(transaction.valor)}
                                </td>
                                <td style={tableCellStyle}>
                                    {transaction.tipo === 'entrada' ? 'Entrada' : 'Saída'}
                                </td>
                                <td style={tableCellStyle}>
                                    {transaction.forma_pagamento}
                                </td>
                                <td style={actionButtonStyle}>
                                    <button
                                        onClick={() => handleEdit(transaction)}
                                        style={iconButtonStyle}
                                    >
                                        <FaEdit size={14} /> {/* Ícone menor */}
                                    </button>
                                    <button
                                        onClick={() => handleDelete(transaction)}
                                        style={{ ...iconButtonStyle, color: "#e74c3c" }}
                                    >
                                        <FaTrash size={14} /> {/* Ícone menor */}
                                    </button>
                                </td>
                            </tr>
                        ))
                    )}
                </tbody>
            </table>

            {editModalOpen && (
                <EditTransactionModal
                    transaction={selectedTransaction}
                    onClose={handleCloseEditModal}
                />
            )}

            {deleteModalOpen && (
                <ConfirmDeleteModal
                    transaction={selectedTransaction}
                    onClose={handleCloseDeleteModal}
                />
            )}
        </div>
    );
};

// --- ESTILOS DA TABELA ---
const tableHeaderStyle = {
    padding: "8px 10px", // Padding menor
    textAlign: "left",
    fontSize: "12px", // Fonte menor
    fontWeight: "bold",
    color: "#555",
};

const tableCellStyle = {
    padding: "8px 10px", // Padding menor
    fontSize: "12px", // Fonte menor
};

const noTransactionsStyle = {
    padding: "15px", // Padding menor
    textAlign: "center",
    fontSize: "13px", // Fonte menor
    color: "#777",
};

const actionButtonStyle = {
    padding: "8px 10px", // Padding menor
    fontSize: "12px", // Fonte menor
    whiteSpace: "nowrap", // Impede quebra de linha dos botões
};

const iconButtonStyle = {
    background: "none",
    border: "none",
    color: "#3498db",
    cursor: "pointer",
    marginRight: "5px", // Margem menor
    padding: "0", // Remove padding padrão do botão
    display: "inline-flex", // Alinha ícone
    alignItems: "center",
    justifyContent: "center",
};

export default TransactionTable;